const log = (typeof window !== 'undefined' && window.location.hostname === 'localhost') ? console.info : () => void 0;
export const DEFAULT_BUS = 'application';
const registry = {};
export function eventBus(namespace = DEFAULT_BUS) {
    if (registry[namespace])
        return registry[namespace];
    const emitter = (global || window).document.createElement('eventbus');
    const bus = {
        once(type, callback) {
            const handler = ((evt) => callback(evt.detail));
            emitter?.addEventListener(type, handler, { once: true });
            return () => emitter?.removeEventListener(type, handler);
        },
        on(type, callback) {
            const handler = ((evt) => callback(evt.detail));
            emitter?.addEventListener(type, handler);
            return () => emitter?.removeEventListener(type, handler);
        },
        emit(type, payload) {
            log('Event: ', type, payload);
            emitter?.dispatchEvent(new CustomEvent(type, { detail: payload }));
        },
    };
    registry[namespace] = bus;
    return bus;
}
export const EventBus = eventBus(DEFAULT_BUS);
//# sourceMappingURL=EventBus.js.map